// removed by extract-text-webpack-plugin
module.exports = {"main":"index__main___3uQbh","container":"index__container___Fwa9d"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Logo/index.styl
 ** module id = 204
 ** module chunks = 0
 **/